import { Question } from "@/types/question"

export const hasQuestionsAnswered = (questions: Question[]): boolean => {
  return questions.every((q) => q.current_value != 0)
}
